// colors
export const textColor = '#464648';
export const BTCSPrimaryColor = '#CF0A2C';
export const BTCSSecondaryColor = '#D72435';

// theme
export const spacingUnit = 8;

// animations
export const easeOut = 'easeOutCubic';
export const easeIn = 'easeInCubic';
export const easeInOut = 'easeInOutCubic';
export const easeInCss = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
export const easeOutCss = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
export const easeInOutCss = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
export const animationDuractionPrimary = 0.9;
export const animationDuractionSecondary = 0.63;
